import { Alert, AlertIcon, Button, Text, useToast } from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ConfirmEmailModal } from "../auth/ConfirmEmailModal";
import { useLoggedInWithOrgContextState } from "../auth/useLoggedInWithOrgContextState";
import { useAppDispatch } from "../redux/hooks";
import { reloadMeThunk } from "../redux/thunks/auth/reload-me-thunk";

export const VerifyEmailBanner = () => {
  const authState = useLoggedInWithOrgContextState();
  const dispatch = useAppDispatch();
  const [isReloading, setIsReloading] = useState(false);
  const toast = useToast();
  const { t } = useTranslation();

  const [showConfirmEmailModal, setShowConfirmEmailModal] = useState(false);

  if (authState.me.emailVerified) return null;

  return (
    <>
      {showConfirmEmailModal && <ConfirmEmailModal onClose={() => setShowConfirmEmailModal(false)} />}
      <Alert status="warning" flexShrink={0}>
        <AlertIcon />
        <Text>
          {t("Please verify your email address")}{" "}
          <Button variant="link" onClick={() => setShowConfirmEmailModal(true)}>
            {authState.me.email}
          </Button>{" "}
          {t("or")}{" "}
          <Button
            variant="link"
            isLoading={isReloading}
            onClick={async () => {
              setIsReloading(true);
              await dispatch(reloadMeThunk());
              setIsReloading(false);
              toast({
                title: `${t("Page reloaded")}!`,
                status: "info",
                position: "top-right",
              });
            }}
          >
            {t("refresh the page")}
          </Button>{" "}
          {t("if it's already done")}
        </Text>
      </Alert>
    </>
  );
};
